module.exports = __webpack_public_path__ + "img/delivery.114931b2.png";